import { useMutation } from '@apollo/client'
import { useApolloClient } from '@apollo/client'
import { useEffect } from 'react'

import {
  SendVerificationEmail,
  SendVerificationEmailMutation,
  SendVerificationEmailMutationVariables,
} from '@/clients/utoniq-core/schema'
import { useAuth, useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { setMailInput } from '@/core/native/storage'
import { clearStorage } from '@/core/native/storage'

import { State } from './template'

type Action = {
  sendVerificationMail: ({ email }: { email: string }) => Promise<void>
  onLogout: () => Promise<void>
}

export const useViewModel = makeViewModel<State, Action>(() => {
  const { router, routerPages } = useRouter()
  const { logout, user } = useAuth()
  const client = useApolloClient()

  const [sendVerifyEmail, { loading: verifyEmailSending }] = useMutation<
    SendVerificationEmailMutation,
    SendVerificationEmailMutationVariables
  >(SendVerificationEmail)

  useEffect(() => {
    if (!user) router.push(routerPages.Top)
    if (user?.email) router.push(routerPages.GlobalHome)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, user?.email])

  return {
    state: {
      loading: verifyEmailSending,
    },
    actions: {
      async sendVerificationMail({ email }) {
        await sendVerifyEmail({ variables: { email } })
        await setMailInput(email)
        router.push(routerPages.MailAuth)
      },
      onLogout: async () => {
        await Promise.all([logout(), client.clearStore(), clearStorage()])

        router.push(routerPages.Top)
      },
    },
  }
})
